/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IComponentOptions} from 'angular';
import {TSBemerkungScope} from '../../../models/enums/TSBemerkungScope';
import {TSRole} from '../../../models/enums/TSRole';
import TSTransitionBemerkung from '../../../models/TSTransitionBemerkung';
import IScope = angular.IScope;

declare let require: any;
let template = require('./dv-status-change-history-list.html');
require('./dv-status-change-history-list.scss');

export class DVStatusChangeHistoryComponentConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        transitionBemerkungen: '=',
        scopeToShow: '<',
        schadenfallId: '<',
    };
    template = template;
    controller = DVStatusChangeHistory;
    controllerAs = 'vm';
}

export class DVStatusChangeHistory {

    transitionBemerkungen: Array<TSTransitionBemerkung> = [];
    sachbearbeiter: Array<TSTransitionBemerkung> = [];
    scopeToShow: Array<TSBemerkungScope> = [];
    schadenfallId: string;

    static $inject: any[] = [
        '$scope',
    ];

    /* @ngInject */
    constructor(
        private $scope: IScope,
    ) {

    }

    $onInit() {
        this.initView();

        this.$scope.$watchCollection(() => {
            return this.transitionBemerkungen;
        }, (newValue, oldValue) => {
            if ((newValue.length !== oldValue.length)) {
                this.initView();
            }
        });
    }

    private initView() {
        this.sachbearbeiter = this.removeDuplicatedSachbearbeiter(this.transitionBemerkungen);
        this.sachbearbeiter = this.sortSachbearbeiter();

        if (this.scopeToShow && this.scopeToShow.length > 0) {
            this.sachbearbeiter = this.sachbearbeiter
                .filter(this.filterByRole());
        }

    }

    private removeDuplicatedSachbearbeiter(array: Array<TSTransitionBemerkung>): TSTransitionBemerkung[] {
        const newArray: any[] = array.map(((elem) => ([elem.getBesitzer()!.id, elem])));
        const newMap = new Map<any, any>(newArray);
        return [...newMap.values()];
    }

    private sortSachbearbeiter() {
        return this.sachbearbeiter.sort((bemerkung1, bemerkung2) => {

            if (bemerkung1.timestampErstellt && bemerkung2.timestampErstellt) {

                if (bemerkung1.timestampErstellt > bemerkung2.timestampErstellt) {
                    return -1;
                }

                if (bemerkung1.timestampErstellt < bemerkung2.timestampErstellt) {
                    return 1;
                }
            }
            return 0;
        });
    }

    private filterByRole() {
        return (bemerkung: TSTransitionBemerkung) => {
            const sachb = bemerkung.getBesitzer();
            return (sachb && (sachb.roles.includes(TSRole.ANLAUFSTELLE_SACHBEARBEITER)
                || sachb.roles.includes(TSRole.ANLAUFSTELLE_SCHAETZER)
                || sachb.roles.includes(TSRole.ANLAUFSTELLE_VERWALTER)
                || sachb.roles.includes(TSRole.FONDSSUISSE_ADMIN)
                || sachb.roles.includes(TSRole.FONDSSUISSE_SACHBEARBEITER)));
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-status-change-history-list/dv-status-change-history-list.ts